import React from 'react';
import { DateParam, Input, Row, SonForm, useForm } from '../../../../_lib/Form2';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import useRedirect from '../../../../hooks/useRedirect';
import { AcceptDeclineForm } from '../../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';

export function ArchivePageForm({ form }: { form: SonForm<DateParam<'archivedDate'>> }) {
  const { t } = useSonTranslation('PageManagement');
  const [startRedirect] = useRedirect();
  const { params } = useForm({ form });

  const archiveDate = params.getByName('archivedDate');

  return (
    <AcceptDeclineForm
      messageSuccess={t('views.navigationsettings-archive.form.status.success')}
      messageSending={t('views.navigationsettings-archive.form.status.sending')}
      messageFail={t('views.navigationsettings-archive.form.status.fail')}
      headline={t('views.navigationsettings-archive.form.question')}
      form={form}
      onSuccess={(response) => {
        if (response?.data?.url) {
          startRedirect(response.data.url);
        }
      }}
    >
      <Row>
        <Input label={t('views.navigationsettings-archive.form.archivedDate.label')} param={archiveDate} />
      </Row>
    </AcceptDeclineForm>
  );
}
